import { AppLog } from "./AppLog";

export const ReadJsonAtUrl = async (url) => {
  try {
    let response = await fetch(url);
    return await response.json();
  } catch (error) {
    AppLog(error);
  }
}